import { render, staticRenderFns } from "./AfterEvent.vue?vue&type=template&id=05c4a7e3"
import script from "./AfterEvent.vue?vue&type=script&lang=js"
export * from "./AfterEvent.vue?vue&type=script&lang=js"
import style0 from "./AfterEvent.vue?vue&type=style&index=0&id=05c4a7e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports